'use strict';

var _ = require('lodash');
var PricingAnalysisPanelController = function PricingAnalysisPanelController($scope, $state, $filter, $q, momentService, currentStateCriteriaService, legendFilterService, pricingAnalysisPanelService) {
  $scope.isDetailsLengthOfStayGridVisible = false;
  $scope.isServicesPanelVisible = false;
  $scope.isCompetitorDataGridVisible = false;
  $scope.isLengthOfStayChartVisible = true;
  $scope.onSearchButtonClick = function () {
    $state.params.transitionData = null;
    $scope.runNumber = undefined;
  };
  $scope.setRunNumber = function () {
    var criteria = currentStateCriteriaService.getSearchCriteria();
    if (criteria && !_.isEmpty(criteria.rules)) {
      var runNumberRule = _.filter(criteria.rules, {
        'criterion': 'Run Number'
      });
      if (!_.isEmpty(runNumberRule)) {
        $scope.runNumber = runNumberRule[0].leftOperand.dropdownVisibleValue;
      } else {
        if (legendFilterService.getSelectedRunNumber()) {
          $scope.runNumber = legendFilterService.getSelectedRunNumber().slice(8);
        } else {
          $scope.runNumber = undefined;
        }
      }
    }
  };
  $scope.setSnapshotDate = function () {
    return pricingAnalysisPanelService.getSnapshotDate().then(function (snapshotDate) {
      $scope.snapshotDate = snapshotDate;
    });
  };
  $scope.setDataFromDashboard = function () {
    var marketFromDashboard = _.get($state.params, 'transitionData.market');
    var cabinFromDashboard = _.get($state.params, 'transitionData.cabin');
    var directionFromDashboard = _.get($state.params, 'transitionData.direction');
    var runNumberFromDashboard = _.get($state.params, 'transitionData.runNumber');
    legendFilterService.setCustomDefaultMarket(marketFromDashboard);
    legendFilterService.setCustomDefaultCabin(cabinFromDashboard);
    legendFilterService.setCustomDefaultDirection(directionFromDashboard);
    legendFilterService.setCustomDefaultRunNumber(runNumberFromDashboard);
  };
};
PricingAnalysisPanelController.$inject = ['$scope', '$state', '$filter', '$q', 'MomentService', 'CurrentStateCriteriaService', 'PricingDepartureDatesLegendFilterService', 'PricingAnalysisPanelService'];
module.exports = PricingAnalysisPanelController;